import { authSlice } from '@store';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const { useLocation, useNavigate } = require('react-router-dom');

const { routes } = require('@constants');
const { useOnlineStatusDetector } = require('./useOnlineStatusDetector');

export const useNavigateWithOfflineMode = () => {
  const navigate = useNavigate();
  const { isOnline } = useOnlineStatusDetector();
  const { pathname } = useLocation();
  const isPopupVisible = useSelector(
    (state) => state.authSlice.isNoNetworkPopupVisible
  );
  const isRouteAvailableOffline = (route) =>
    route === routes.offlineContent || /^\/courses\/\d+\/\d+$/.test(route);
  const dispatch = useDispatch();
  const showNoNetworkPopup = () => {
    if (!isPopupVisible) {
      dispatch(authSlice.actions.setIsNoNetworkPopupVisible(true));
      setTimeout(() => {
        dispatch(authSlice.actions.setIsNoNetworkPopupVisible(false));
        if (!isRouteAvailableOffline(pathname)) navigate(routes.offlineContent);
      }, 2000);
    }
  };

  useEffect(() => {
    dispatch(authSlice.actions.setIsNoNetworkPopupVisible(false));
  }, []);

  const handleNavigation = (route, options) => {
    const isAvailableOffline = isRouteAvailableOffline(route);

    if (isOnline || isAvailableOffline) {
      navigate(route, options);
      return 0;
    }
    showNoNetworkPopup();

    return 0;
  };

  return { isPopupVisible, navigate: handleNavigation };
};
